module.exports = __webpack_public_path__ + "static/media/img_general_logo.973bc775.svg";